import React from 'react';
import Search from '../components/home/Search';
import CharacterList from '../components/home/CharacterList';

const Home = () => {
  return (
    <div>
      <Search />
      <CharacterList />
    </div>
  );
};

export default Home;
